import "/src/style/main.scss"

import AOS from 'aos';
AOS.init({
    offset: 100,
    duration: 600,
    delay: 100,
    once: true,
});

// Other
import "./functions";

// Modules
import SiteHeader from "./modules/site-header";
SiteHeader().init()

import SiteNav from "./modules/site-nav";
SiteNav().init()

import Slider from "./modules/slider";
Slider().init()

import EventSlider from "./modules/events-slider";
EventSlider().init()

import Testimonials from "./modules/testimonials";
Testimonials().init()

import MobileNav from "./modules/site-nav-mobile";
MobileNav().init()

import Accordions from "./modules/accordions";
Accordions().init()

import Quizz from "./templates/quizz";
Quizz().init()

import Events from "./templates/events";
Events().init()


// Templates

// Template parts

// Pages
